import { Icon } from 'src/components/icon/Icon';
import { Box, IconButton } from 'src/components/mui';
import { useMenuContext } from '../../context';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
  icon: string | React.ReactNode;
  hasBeenOpened: boolean;
  openOnHover?: boolean;
  active?: boolean;
  bgColor?: string;
  textColor?: string;
};

export default function Button({
  onOpen,
  onClose,
  setMenuIsOpen,
  menuIsOpen,
  icon,
  hasBeenOpened,
  openOnHover,
  active,
  bgColor,
  textColor,
}: Props) {
  const { rtl } = useMenuContext();

  return (
    <Box
      onMouseEnter={
        openOnHover && !menuIsOpen
          ? () => {
              onOpen();
              setTimeout(() => {
                setMenuIsOpen(true);
              }, 300);
            }
          : undefined
      }
      sx={{
        ...(rtl && !hasBeenOpened
          ? {
              marginLeft: '16px !important',
            }
          : {}),
      }}
    >
      <IconButton
        sx={{
          background: bgColor,
          color: textColor || 'white',
          ...(!hasBeenOpened ? { width: '50px', paddingRight: '17px' } : {}),
          '&:hover': {
            background: bgColor,
            opacity: 0.8,
          },

          borderRadius: '10px 0 0 10px',
        }}
        onClick={active ? onClose : onOpen}
      >
        {active ? (
          <Icon type="fas" icon="fa-xmark" color={textColor} />
        ) : typeof icon === 'string' ? (
          <Icon type="fas" icon={icon} color={textColor} />
        ) : (
          icon
        )}
      </IconButton>
    </Box>
  );
}
